<template>
	<button :class="[`share-btn ${direction}`,{'isActive':showPopup}]" @click="handleClick">

    <svg-share></svg-share>

    <slot></slot>

    <Transition name="fade">
      <div class="share-btn-icons-container">
        <ul class="share-btn-icons">
          <li>
            <block-social-media-share network="facebook" :title="computedTitle"></block-social-media-share>
          </li>
          <li>
            <block-social-media-share network="twitter" :title="computedTitle"></block-social-media-share>
          </li>
          <li>
            <block-social-media-share network="linkedin" :title="computedTitle"></block-social-media-share>
          </li>
          <li>
            <block-social-media-share network="whatsapp" :title="computedTitle"></block-social-media-share>
          </li>
        </ul>
      </div>
    </Transition>
  </button>

</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';

	export default {
		name: 'ShareButton',
		mixins: [AuthMixins],

		props: {
			job_title: {
				type: String
			},
      direction: {
        type: String,
        default: 'right'
      }
		},

		data() {
			return {
        showPopup: false
			}
		},

		mounted() {

		},

		methods: {
			handleClick() {
        this.showPopup = !this.showPopup;
			},
      handleMouseenter() {
        if (this.$screen.width > 768) {
          this.showPopup = true;
        }
      },
      handleMouseleave() {
        if (this.$screen.width > 768) {
          this.showPopup = false;
        }
      }
		},

    computed: {
      computedTitle() {
        return encodeURIComponent(this.job_title);
      }
    }
	}

</script>
